import { Entidad } from "../../../data/Entidad";
import { _ModalServiceIterator } from "./ModalServiceIterator";
import { IModalServiceIteratorBasicConfig } from "./ModalServiceIteratorBasic";
import { _ModalToAProccess } from "./ModalToAProccess";
import { ModalThingsUtil as util } from "./Utils";

type IModalThings<Extras = any> = util.IModalThings<Extras>
type IResponseItemData<Data> = util.IResponseItemData<Data>

export interface IModalServiceIteratorAdvanceConfig<TData> extends Omit<IModalServiceIteratorBasicConfig<TData>, keyof Pick<IModalServiceIteratorBasicConfig<TData>, "DataToProccess" | "Message" | "StrModalBotons" | "TypeRequest">> {
    TypeRequest?: Entidad.CTipoRequest;
    OnGetDataToProccess: () => TData[];
    OnDrawContent: (content: TSelectionHTML<"div">, modalThings: IModalThings) => void;
    OnEndAndCloseProccess?: (datosCorrectos: TData[], allDataProccess: IResponseItemData<TData>[]) => void;
    OnValideData?: (modalThings: IModalThings) => boolean;
}

export async function _ModalServiceIteratorAdvance<TData>(config: IModalServiceIteratorAdvanceConfig<TData>): Promise<IResponseItemData<TData>[] | null> {
    const resultData = await new Promise<IResponseItemData<TData>[]>((resolve) => {
        let dataProccess: IResponseItemData<TData>[] = [];

        _ModalToAProccess({
            Title: config.Title,

            IdsEscuelas: config.IdsEscuelas,
            Modulo: config.Modulo,
            Action: config.Action,
            // AccionToHttpMessage: config.AccionToHttpMessage,

            LangModuleKeyInContext: config.LangModuleKeyInContext,
            Width: (config.Width || 500),
            DrawContent: config.OnDrawContent,
            OnAccept: async (modalThings) => {
                if (config.OnValideData && !config.OnValideData(modalThings)) {
                    return null;
                }

                dataProccess = config.OnGetDataToProccess()
                    .map(d => ({
                        Resultado: -1,
                        ItemData: d,
                        TipoRequest: config.TypeRequest,
                    }));

                // >> Proceso
                await _ModalServiceIterator(modalThings, dataProccess, config);

                // >> Fin
                modalThings.Modal._Ocultar();
                return null;
            },
            OnClose: () => resolve(dataProccess)
        })
    });

    if (config.OnEndAndCloseProccess) {
        const datosCorrectos = resultData
            .filter(d => (d.Resultado > 0))
            .map(d => d.ItemData);

        config.OnEndAndCloseProccess(datosCorrectos, resultData);
    }

    return resultData;
}